Vendd.Scripts.load(function () {
    var $wrapper = $('.x-product-list'),
        wrapper,
        $multipleAddButton = $('.js-add-selected'),
        $configuration, configuration,
        $resultsFancyboxLink = $('.results-fancybox-link'), $resultsWraper = $('.js-results-wrapper'),
        isScrolled = $wrapper.data('scrolled') === true,
        hasQuickbuy = $wrapper.data('quickbuy') === true,
		previousPage = isScrolled ? parseInt($wrapper.data('previous-page')) : 0,
        currentPage = isScrolled ? parseInt($wrapper.data('current-page')) : 0,
		nextPage = isScrolled ? parseInt($wrapper.data('next-page')) : 0,
		totalPages = isScrolled ? parseInt($wrapper.data('total-pages')) : 0,
		forwardUpdates = 0,
		forwardUpdatesCup = 2,
		backwardUpdates = 0,
		backwardUpdatesCup = 0;

    var model = null;

    if ($resultsFancyboxLink.length > 0) {
        $resultsFancyboxLink.fancybox({
            type: 'inline',
        });
    }

    if ($wrapper.length < 1)
        return;

    if ($wrapper.hasClass("js-lazyload") && typeof $.fn.lazyload === "function") {
        $("img[data-lazyload]", $wrapper).lazyload({
            effect: 'fadeIn',
            threshold: 500,
            skip_invisible: false
        }).removeAttr("data-lazyload");
    };

    wrapper = $wrapper.get(0);

    $configuration = $('.configuration', $wrapper);

    configuration = $configuration.text();
    $configuration.remove();

	if (hasQuickbuy) {
		$('.wrapper-to-delete').remove();
		Vendd.MessageBus.publishAsync(wrapper, new Vendd.ScrollList.Messages.GetCurrentPage(wrapper, configuration, 'productList'));
	}

	Vendd.MessageBus.publishAsync(wrapper, new Vendd.Widget.Messages.BindControl($wrapper));

	var loading = false,
		hasNext = true,
		hasPrevious = true,
		initialCall = true;

	wrapper.loading = function (option, direction) {
		loading = option;
		if (option === true) {
			$wrapper.addClass('x-loading');
			$('.scrolllist-pager-notification').addClass('disabled');
			$('.scrolllist-pager-notification[data-direction="' + direction + '"]').addClass('x-loading');
		} else {
			$wrapper.removeClass('x-loading');

			if (direction === 'forward') {
				if (forwardUpdates >= forwardUpdatesCup) {
					$('.scrolllist-pager-notification[data-direction="backward"]').removeClass('disabled');
					$('.scrolllist-pager-notification[data-direction="forward"]').removeClass('disabled x-loading');
				}
			}
			else if (direction === 'backward') {
				if (backwardUpdates >= backwardUpdatesCup) {
					$('.scrolllist-pager-notification[data-direction="forward"]').removeClass('disabled');
					$('.scrolllist-pager-notification[data-direction="backward"]').removeClass('disabled x-loading');
				}
			} else {
				$('.scrolllist-pager-notification').removeClass('disabled x-loading');
			}
		};
	};

	wrapper.onSuccess = function (envelope) {
		if (envelope.message.data.list !== wrapper)
			return;
		var direction = '';
		model = envelope.message.data.model;

		if (model.Items.length === 0) {

			if (envelope.message.data.position == 'BottomOfList') {
				hasNext = false;
				direction = 'forward';
			}
			if (envelope.message.data.position == 'TopOfList') {
				hasPrevious = false;
				direction = 'backward';
			}
			wrapper.loading(false, direction);
			return;
		};

		if (!isTouch() && model.HasQuickBuy && model.Items.length > 0) {
			Vendd.Quickbuy.addToQuickbuyList(model.Items[0], true);
		}

		var html = Vendd.Handlebars.parse(Handlebars.partials.productList, model);

		var $html = $(html),
			$list = $('> ul', $wrapper),
			$boxes,
			items, lastItem, grouping, rowSize;

        configuration = $('.configuration', $html).text();

		Vendd.MessageBus.publish(wrapper, new Vendd.Widget.Messages.BindControl($html));

		$boxes = $('.x-product-box', $html);

		lastItem = $list.children().last();
		grouping = $html.data('grouping');
		rowSize = 3;

		items = wrapBoxes($boxes, grouping, rowSize, lastItem);
		if (envelope.message.data.position == 'BottomOfList') {
			if (parseInt($wrapper.attr('data-total-pages')) == model.PageNumber) {
				$('.scrolllist-pager-notification[data-direction="forward"]').remove();
				$('.scrolllist-pager-notification[data-direction="backward"]').removeClass('disabled');
			} else {
				$('.scrolllist-pager-notification[data-direction="forward"] .current-page').html(model.PageNumber);
			}

			var indicator = $('.page-indicator', $wrapper).eq(0).clone();
			indicator.attr('data-page', model.PageNumber);
			$('.page-number', indicator).html(model.PageNumber);
			$list.append(indicator);
			$list.append(items);
			$('.page-indicator', $wrapper).removeClass('hidden');
			direction = 'forward';
		}

		if (envelope.message.data.position == 'TopOfList') {
			if (model.PageNumber == 1) {
				$('.scrolllist-pager-notification[data-direction="backward"]').remove();
				$('.scrolllist-pager-notification[data-direction="forward"]').removeClass('disabled');
			} else {
				$('.scrolllist-pager-notification[data-direction="backward"] .current-page').html(model.PageNumber);
			}
			var elementFocused = $(' >ul >li', $wrapper).eq(0),
				initPos = elementFocused.parent().offset().top, latePos,
				windowPos = $(window).scrollTop(),
				indicator = $('.page-indicator', $wrapper).eq(0).clone();

			indicator.attr('data-page', model.PageNumber);
			$('.page-number', indicator).html(model.PageNumber);
			$list.prepend(items);
			$list.prepend(indicator);
			$('.page-indicator', $wrapper).removeClass('hidden');
			latePos = elementFocused.offset().top;
			$('html,body').scrollTop(windowPos + latePos - initPos);

			direction = 'backward';
		}

        if ($wrapper.hasClass("js-lazyload") && typeof $.fn.lazyload === "function") {
            $("img[data-lazyload]", $wrapper).lazyload({
                effect: 'fadeIn',
                threshold: 500,
                skip_invisible: false
            }).removeAttr("data-lazyload");
        };
        wrapper.loading(false, direction);

    };

	wrapper.onFailure = function (envelope) {
		if (envelope.message.data.list !== wrapper)
			return;

		var direction = '';

		if (envelope.message.data.position == 'BottomOfList') {
			direction = 'forward';
		}
		if (envelope.message.data.position == 'TopOfList') {
			direction = 'backward';
		}
		wrapper.loading(false, direction);
	};

	wrapper.onFailureCurrent = function (envelope) {
		_LTracker.push({
			"Message Error": {
				"message": "Quickbuy couldn't be initialized, in Product list",
				"publisher": "Vendd.ScrollList.Messages.GetCurrentPageFailure"
			}
		});
	};
	wrapper.onSuccessCurrent = function (envelope) {

		var model = envelope.message.data.model;

        //if (model.Items.length > 0) {
        //    Vendd.Quickbuy.addToQuickbuyList(model.Items);
        //};
        Vendd.Quickbuy.addToQuickbuyList(model);

		$wrapper.removeClass('quickbuy-loading');
	};

	wrapper.update = function (dataListMovement) {

		if (loading)
			return;

		if (dataListMovement == 'forward') {
			hasNext = totalPages > parseInt($('>ul>li[data-page]', $wrapper).eq($('>ul>li[data-page]', $wrapper).length - 1).attr('data-page'));
			if (!hasNext) {
				return;
			}
		}
		if (dataListMovement == 'backward') {
			hasPrevious = parseInt($('>ul>li[data-page]', $wrapper).eq(0).attr('data-page')) > 1;
			if (!hasPrevious) {
				return;
			}
		}

		wrapper.loading(true, dataListMovement);
		if (dataListMovement == 'forward') {
			Vendd.MessageBus.publishAsync(wrapper, new Vendd.ScrollList.Messages.GetNextPage(wrapper, configuration, 'productList'));
		}
		if (dataListMovement == 'backward') {
			Vendd.MessageBus.publishAsync(wrapper, new Vendd.ScrollList.Messages.GetPreviousPage(wrapper, configuration, 'productList'));
		}

	};

	$wrapper.on('click', '.js-select', function (e) {

		if ($(this).hasClass('selected')) {
			$(this).removeClass('selected');
		} else {
			$(this).addClass('selected');
		}

		updateButtonStatus();
	});

	$('.scrolllist-pager-notification').on('click', '.js-show', function () {
		if (!$(this).closest('.scrolllist-pager-notification').hasClass('disabled')) {
			if ($(this).data('direction') === 'forward') forwardUpdates = 0;
			else if ($(this).data('direction') === 'backward') backwardUpdates = 0;
			wrapper.update($(this).data('direction'));
		}
	});

	$multipleAddButton.on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();

		var $this = $(this), $boxes = $('.x-product-box', wrapper);

		if ($boxes.length < 1) {
			$this.attr('disabled', 'disabled').addClass('disabled');
			return;
		}

		var data = [], prObj;

		$boxes.each(function (i, el) {
			var $el = $(el);

			if ($el.find('.js-select').hasClass('selected')) {

				prObj = {
					id: $el.data('productid'),
					skuId: $el.data('variantid'),
					path: $el.data('path'),
					qty: 1
				};

				data.push(prObj);
			}
		});

		if (data.length > 0) {
			Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.MultipleAdd(data));
		}
	});

	var handleMulitpleAddResult = function (data) {
		var html = Vendd.Handlebars.parse(Handlebars.partials.MultipleAddResults, JSON.parse(data));

		$resultsWraper.html(html);
		$resultsFancyboxLink.trigger('click');
	};

	var updateButtonStatus = function (e) {
		var isChecked = false;

		var $boxes = $('.x-product-box', wrapper);

		$boxes.each(function (i, el) {
			var $el = $(el);
			if ($el.find('.js-select').hasClass('selected')) {
				$multipleAddButton.removeAttr('disabled').removeClass('disabled');
				isChecked = true;
				return;
			}
		});

		if (isChecked) return;

		$multipleAddButton.attr('disabled', 'disabled').addClass('disabled');
	};

	var ReplacePrices = function (obj) {
		$('.x-product-box[data-productid]').each(function (i, el) {
			var itemId = parseInt($(el).attr('data-productid'));
			var itemData = obj.filter(function (a) { return a.Id === itemId })[0]

			var DeletedPrice = parseFloat(itemData.DeletedPrice);
			var Price = parseFloat(itemData.Price);
			var TotalPointsPrice = parseFloat(itemData.TotalPointsPrice);
			var TotalPointsGain = parseFloat(itemData.TotalPointsGain);
			var PointsPrice = parseFloat(itemData.PointsPrice);
			var PointsGain = parseFloat(itemData.PointsGain);

			// hide all
			$('.prices', el).addClass('hide');
			$('.deleted-price-container', el).addClass('hide');
			$('.current-price-container', el).addClass('hide');
			$('.current-point-price-container.1', el).addClass('hide');
			$('.current-point-price-container.2', el).addClass('hide');
			$('.current-point-price-container.3', el).addClass('hide');
			$('.current-point-price-container.4', el).addClass('hide');

			if (DeletedPrice > 0 || Price > 0 || TotalPointsPrice > 0 || TotalPointsGain > 0 || PointsPrice > 0 || PointsGain > 0) {
				$('.prices', el).removeClass('hide');

				if ((DeletedPrice > 0) && (DeletedPrice > Price)) {
					$('.deleted-price-container', el).removeClass('hide');
					$('.deleted-price', el).text(RenderPrice(itemData.DeletedPrice));
				}

				if (Price > 0) {
					$('.current-price-container', el).removeClass('hide');
					$('.current-price', el).text(RenderPrice(itemData.Price));
				}

				if (PointsPrice > 0 && PointsPrice != TotalPointsPrice) {
					$('.current-point-price-container.1', el).removeClass('hide');
					$('.current-point-price-container.1 .points-price', el).text(RenderPointsPrice(PointsPrice));
				}

				if (TotalPointsGain > 0) {
					$('.current-point-price-container.2', el).removeClass('hide');
					$('.current-point-price-container.2 .points-gain', el).text(RenderPointsPrice(TotalPointsGain));
				}

				if (PointsGain > 0 && TotalPointsGain === 0) {
					$('.current-point-price-container.3', el).removeClass('hide');
					$('.current-point-price-container.3 .points-gain', el).text(RenderPointsPrice(PointsGain));
				}

				if (TotalPointsPrice > 0) {
					$('.current-point-price-container.4', el).removeClass('hide');
					$('.current-point-price-container.4 .points-price', el).text(RenderPointsPrice(TotalPointsPrice));
				}
			}
		});
	}

	var ReplaceAvailabilities = function (obj) {
		$('.x-product-box[data-productid]').each(function (i, el) {
			var itemId = parseInt($(el).attr('data-productid'));
			var itemData = obj.filter(function (a) { return a.Id === itemId })[0]

			var cartEnabled = itemData.CanBuy === true || itemData.CanBuyWithPoints === true;
			var wishlistEnabled = itemData.CanAddToList === true;

			if ($('.buttons .add-to-cart').length > 0 && $('.buttons .add-to-cart input').length > 0) {
				$('.buttons .add-to-cart').addClass('x-disabled');
				$('.buttons .add-to-cart input').attr('disabled', 'disabled');

				if (cartEnabled === true) {
					$('.buttons .add-to-cart').removeClass('x-disabled');
					$('.buttons .add-to-cart input').removeAttr('disabled', 'disabled');
				}
			}

			//if ($('.buttons .add-to-wishlist').length > 0 && $('.buttons .add-to-wishlist input').length > 0) {
			//$('.buttons .add-to-wishlist').addClass('x-disabled');
			//$('.buttons .add-to-wishlist input').attr('disabled', 'disabled');

			//if (wishlistEnabled === true) {
			//$('.buttons .add-to-wishlist').removeClass('x-disabled');
			//$('.buttons .add-to-wishlist input').removeAttr('disabled', 'disabled');
			//}
			//}
		});
	}

	wrapper.onGetClientProductListDataSuccess = function (envelope) {
		var obj = JSON && JSON.parse(envelope.message.data) || $.parseJSON(envelope.message.data);
		ReplacePrices(obj.ItemsPrices);
		ReplaceAvailabilities(obj.ItemsAvailabilities);
	}

	wrapper.onGetClientProductListDataFailure = function (envelope) {
		//console.log(envelope.message.data);
	}
	wrapper.updatePageUrl = function () {

		var element = _.first(_.filter($('>ul>li[data-page]', $wrapper), function (element) { return $(window).scrollTop() <= $(element).offset().top; })),
			pageNumber = $(element).length ? $(element).data('page') : $('>ul>li[data-page]', $wrapper).eq($('>ul>li[data-page]', $wrapper).length - 1).data('page'),
			pager = $('.x-pager[data-page-count]'),
			pageCount = pager.length ? (parseInt(pager.attr('data-page-count')) || 0) : 0,
			comboPagers = $('.pager .x-pager-combopages');

		comboPagers.each(function (index, comboPager) {
			var $comboPager = $(comboPager);
			$('select', $comboPager).addClass('disabled');
			$('.newList>li a', $('select', $comboPager).siblings('.newListSelected')).eq(pageNumber - 1).trigger('click');
			$('select', $comboPager).removeClass('disabled');
		});

		if (history.pushState) {

			var querystring = window.location.pathname + (window.location.pathname.slice(-1) != "/" ? "/" : ""),
				pageText = pageNumber > 1 ? "p" + pageNumber + "/" : "";

			if (!(/\/P\d+\//i.test(querystring))) {
				querystring = querystring + pageText;
			} else {
				querystring = querystring.replace(/\/P\d+\//i, "/" + pageText);
			}

			var stateObject = {};
			var url = window.location.protocol
				+ "//"
				+ window.location.host
				+ querystring
				+ window.location.search;

            if (window.location.href !== url) {
                var prev = $("head link[rel=prev]");
                var next = $("head link[rel=next]");
                var prevLink = url.replace(/^(.+\/p)\d+(\/?(\?.*)?)?$/i, "$1" + (pageNumber - 1) + "$2");
                var nextLink = url.replace(/^(.+\/p)\d+(\/?(\?.*)?)?$/i, "$1" + (pageNumber + 1) + "$2");
                if (prev) {
                    if (pageNumber > 1) {
                        prev.attr("href", prevLink);
                    } else {
                        prev.remove();
                    }
                } else if (pageNumber > 1) {
                    $("head").append("link rel=\"prev\" href=\"" + prevLink + "\" />");
                }
                if (next) {
                    if (pageNumber < pageCount) {
                        next.attr("href", nextLink);
                    } else {
                        next.remove();
                    }
                } else if (pageNumber < pageCount) {
                    $("head").append("link rel=\"next\" href=\"" + nextLink + "\" />");
                }
                history.replaceState(stateObject, jQuery(document).find('title').text() + pageNumber, url);
            }
        }
    }

    Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetPageSuccess, wrapper, wrapper.onSuccess);
    Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetNextPageFailure, wrapper, wrapper.onFailure);
    Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetCurrentPageSuccess, wrapper, wrapper.onSuccessCurrent);
    Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetCurrentPageFailure, wrapper, wrapper.onFailureCurrent);
    Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetPreviousPageFailure, wrapper, wrapper.onFailure);
    Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetClientProductListDataSuccess, wrapper, wrapper.onGetClientProductListDataSuccess);
    Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetClientProductListDataFailure, wrapper, wrapper.onGetClientProductListDataFailure);

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.MultipleAddSuccess, this, function (envelope) {
        handleMulitpleAddResult(envelope.message.data.model.data);
    });

    function wrapBoxes($boxes, grouping, rowSize, lastItem) {
        var items = [],
            currentIndex, cssClass;

        lastItem.removeClass('last');

        currentIndex = lastItem.data('index') + 1;

        for (var i = 0; i < $boxes.length; i++) {
            var li = $('<li>');

            cssClass = "index" + currentIndex;
            cssClass += (currentIndex % 2) ? " odd" : " even";
            cssClass += (i === $boxes.length - 1) ? " last" : "";
            cssClass += currentIndex % rowSize === 0 ? " row-first" : "";
            cssClass += (currentIndex + 1) % rowSize === 0 ? " row-last" : "";

            li.append($boxes.eq(i))
                .addClass(cssClass)
                .attr('data-index', currentIndex)
				.attr('data-page', model.PageNumber);

            items.push(li);

            currentIndex++;
        };

        return items;
    };

    if (isScrolled === true) {
        $(window).scroll($.debounce(300, function () {
            if (($(window).scrollTop() == 0 || $wrapper.offset().top > $(window).scrollTop()) && backwardUpdates < backwardUpdatesCup) {
                backwardUpdates++;
                wrapper.update('backward');
            }
			if (($(window).scrollTop() >= $(document).height() - $(window).height() - $('.footer-region').height() - 500 || isElementInViewport($('.scrolllist-pager-notification'))) && forwardUpdates < forwardUpdatesCup ) {
                forwardUpdates++;
                wrapper.update('forward');
            }
            if ($(window).scrollTop() >= 0 && !loading) {
                wrapper.updatePageUrl();
            }

        }));
    };

    var lazyLoadPricesList = $('.list-lazy-load-prices').text().toLowerCase().trim() === "true";

    var wrapperList = $('.x-product-list');
    if (wrapperList.length > 0 && true === lazyLoadPricesList) {
        var items = [];
        $('.x-product-box[data-productid]').each(function (i, el) {
            items.push(parseInt($(el).attr('data-productid')));
        });

        var obj = {
            itemIds: items,
            fetchPrices: true,
            fetchAvailabilities: true,
            fetchStock: true
        };
        Vendd.MessageBus.publishAsync(wrapperList, new Vendd.ScrollList.Messages.GetClientProductListData(obj));
    }

    $wrapper.on('click', '.js-related-product .header', function (e) {
        $(this).closest('.js-related-product').find('.content').slideToggle();
        $(this).find('.icon-plus').toggle();
        $(this).find('.icon-minus').toggle();
    });
});